import { render, staticRenderFns } from "./agree-shuguang.vue?vue&type=template&id=508cb644&scoped=true&"
import script from "./agree-shuguang.vue?vue&type=script&lang=ts&"
export * from "./agree-shuguang.vue?vue&type=script&lang=ts&"
import style0 from "./agree-shuguang.vue?vue&type=style&index=0&id=508cb644&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508cb644",
  null
  
)

export default component.exports